module.exports = __webpack_public_path__ + "static/media/lepes7.6b550d35.png";